import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";
import type { MemberRole } from "./api";

const ITEMS = [
  { to: "/", label: "Frise" },
  { to: "/questions", label: "Questions" },
  { to: "/proches", label: "Proches" },
  { to: "/reglages", label: "Réglages" },
] as const;

/**
 * La navigation de l'app, une fois connecte (planches « Main » et « FriseConstellation ») : des
 * onglets en tete de page au bureau, une barre fixee en bas au telephone. L'en-tete et le pied de
 * page restent ceux du template. Un proche (ticket 7) ne voit que la Frise : les autres pages
 * sont au proprietaire seul, et le serveur le lui refuserait de toute facon (403 `owner_only`).
 */
export function AppNav({ viewerRole = "owner" }: { viewerRole?: MemberRole }) {
  const items = viewerRole === "owner" ? ITEMS : ITEMS.filter((item) => item.to === "/");
  return (
    <nav
      aria-label="Ma timeline"
      className={`fixed inset-x-0 bottom-0 z-20 grid ${items.length === 1 ? "grid-cols-1" : "grid-cols-4"} border-t border-[rgba(243,238,227,0.10)] bg-background md:static md:flex md:gap-6 md:border-0 md:bg-transparent`}
    >
      {items.map((item) => (
        <Link
          activeOptions={{ exact: true }}
          activeProps={{
            "aria-current": "page",
            className: "font-semibold text-foreground md:border-b-2 md:border-foreground",
          }}
          className="flex min-h-14 items-center justify-center text-xs text-muted-foreground no-underline md:min-h-11 md:text-sm"
          inactiveProps={{ className: "hover:text-foreground" }}
          key={item.to}
          to={item.to}
        >
          {item.label}
        </Link>
      ))}
    </nav>
  );
}

/** La page d'un ecran connecte : la navigation, puis le contenu, avec la place de la barre du bas. */
export function AppPage({
  children,
  viewerRole,
}: {
  children: ReactNode;
  viewerRole?: MemberRole;
}) {
  return (
    <div className="flex flex-col gap-6 pb-20 md:pb-0">
      <AppNav {...(viewerRole === undefined ? {} : { viewerRole })} />
      {children}
    </div>
  );
}
